import { ApplicationError } from '@/src/shared/errors';

export class LoginFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal melakukan login, silahkan coba beberapa saat lagi');
  }
}

export class InvalidCredentialsError extends ApplicationError {
  constructor() {
    super('Error', 'Username atau kata sandi yang Anda masukkan salah');
  }
}

export class RegistrationFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal melakukan registrasi, silahkan coba beberapa saat lagi'
    );
  }
}

export class UsernameEmailPhoneNumberAlreadyExistError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Username, email, atau nomor telepon sudah terdaftar, silahkan gunakan yang lain'
    );
  }
}

export class InvalidOTPError extends ApplicationError {
  constructor() {
    super('Error', 'Kode OTP yang Anda masukkan tidak valid');
  }
}

export class OTPExpiredError extends ApplicationError {
  constructor() {
    super('Error', 'Kode OTP yang Anda masukkan telah kedaluwarsa');
  }
}

export class VerifyOTPFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memverifikasi kode OTP, silahkan coba beberapa saat lagi'
    );
  }
}

export class ResendOTPFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal mengirim ulang kode OTP, silahkan coba beberapa saat lagi'
    );
  }
}

export class ForgotPassFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal melakukan atur ulang kata sandi, silahkan coba beberapa saat lagi'
    );
  }
}

export class ForgotPassEmailError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Silahkan masukkan email yang sudah terdaftar atau lakukan registrasi terlebih dahulu.'
    );
  }
}

export class GenerateSessionTokenFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal menghasilkan token, silahkan coba beberapa saat lagi'
    );
  }
}

export class DestroySessionTokenFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal menghancurkan token, silahkan coba beberapa saat lagi'
    );
  }
}
